(function () {
    'use strict';

    angular.module("imApp").factory("stockLocationService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 936,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 937,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 938,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
